import { render, staticRenderFns } from "./PortTradeflows.vue?vue&type=template&id=3e32a963&scoped=true&"
import script from "./PortTradeflows.vue?vue&type=script&lang=js&"
export * from "./PortTradeflows.vue?vue&type=script&lang=js&"
import style0 from "./PortTradeflows.vue?vue&type=style&index=0&id=3e32a963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e32a963",
  null
  
)

export default component.exports